import React, { useState } from "react";
import BankIcon from "../../assets/bank_icon.png";
import RewardsIcon from "../../assets/rewards-icon.png";
import { Link } from 'react-router-dom';
import ArrowLeft from "../../assets/left-icon.png";
import { GrFormCheckmark } from "react-icons/gr";


export default function DepositFiat() {
    const [selectedAmount, setSelectedAmount] = useState(0);
    const [isOpen, setIsOpen] = useState(false)

    const handleAmountSelect = (amount) => {
        setSelectedAmount(amount);
    };

    return (
        <>
            <div className='rewards_section'>
                <div className='container'>
                    <div className='rewards_heading'>
                        <img src={RewardsIcon} />
                        <p>Book Now & Earn Rewards</p>
                    </div>
                </div>
            </div>

            <div className='crypto-deposit'>
                <div className='inner_title_section'>
                    <div className='container'>
                        <div className='inner_title_flex'>
                            <Link to='/wallet'> <img src={ArrowLeft} /></Link>
                            <h3>Bank Deposit</h3>
                        </div>
                    </div>
                </div>

                <div className='container'>
                    <div className='crypto_inner'>
                        <div className='crypto_form input_outer'>
                            <div className='avail_balance'>
                                <h5>Account Available Balance</h5>
                                <h6>₹ 0.00</h6>
                            </div>
                            <div className='form-group-crypto'>
                                <label>Select Crypto</label>
                                <div className='fiat_deposit_method'>
                                    <img src={BankIcon} />
                                    <span>Bank</span>
                                    <div className='bank_checkbox'>
                                        <input type='checkbox' checked={true} className="bank_check_input" />
                                    </div>
                                </div>
                            </div>
                            <div className='form-group-crypto'>
                                <label>Deposit Amount</label>
                                <input
                                    type='text'
                                    value={selectedAmount}
                                    onChange={(e) => setSelectedAmount(e.target.value)}
                                />
                            </div>

                            <div className='default_deposit_amount'>
                                {[10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000].map((amount) => (
                                    <button key={amount} onClick={() => handleAmountSelect(amount)}>
                                        ₹ {amount}
                                    </button>
                                ))}
                            </div>
                            <p className=''>Selected Amount: ₹{selectedAmount}</p>
                            <div className='deposit_btn'>
                                <button onClick={() => setIsOpen(true)}>Deposit</button>
                            </div>
                        </div>
                        <div className='deposit_note_box'>
                            <h5>Notes</h5>
                            <ul className='notes_list'>
                                <li>1.Users can choose What’sapp and telegram option for own topup and recharges.</li>
                                <li>2.After making the transfer according to the account provided by the customer service of the platform, be sure to submit the receipt of successful transfer or other relevant screenshots to the account for system verification purpose.</li>
                                <li>3.System will generating the bank accounts by user request , so it will be updating time to time.</li>
                                <li>4.After receiving the bank account, the transfer should be done within the time given by the respective customer support.</li>
                                <li>5.Contact customer support based on your preference as to which online transaction modes are required to conduct transactions.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {isOpen && (
                    <div className="popup-overlay" onClick={() => setIsOpen(false)}>
                        <div className="popup-box" onClick={(e) => e.stopPropagation()}>
                            <div className="popup-content">
                                <div className='level_modal'>
                                    <div className="tele_link_icon">
                                        <button className="whats_button">Whatsapp</button>
                                    </div>
                                    <div className="what_link_icon">
                                        <button className="whats_button" onClick={() => window.open("/deposit-fiat", "_blank")}>Telegram</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
